const data = {
    "consumo-annuo": {
      label: "Consumo annuo",
      description: "Indica il totale dei tuoi consumi nell'ultimo anno. Qualora non sia disponibile un dato effettivo faremo una stima. Nel caso in cui la tua fornitura sia attiva da meno di 12 mesi, il consumo annuo si chiamerà \"consumo da inizio fornitura\".",
      labelKeywords: ["consumo", "annuo", "annuale"],
      contentKeywords: ["consumo", "annuo", "annuale"],
      img: "./images/03-consumi-01-consumifatturati-01-consumoannuo.jpg",
      imgDescription: "Immagine che raffigura la seconda pagina della bolletta, con evidenziato il campo Consumo annuo"
    },

    "consumi-effettivi": {
      label: "Consumi effettivi",
      description: "Sono i kWh effettivamente consumati calcolati facendo la differenza tra due letture reali.",
      labelKeywords: ["consumi", "consumo", "effettivi", "effettivo"],
      contentKeywords: ["consumi", "consumo", "effettivi", "effettivo"],
      img: "./images/03-consumi-01-consumifatturati-02-consumieffettivi.jpg",
      imgDescription: "Immagine che raffigura la seconda pagina della bolletta, con evidenziato il campo Consumi effettivi"
    },

    "consumo-stimato": {
      label: "Consumo stimato",
      description: "In mancanza di letture rilevate o di autoletture, il consumo viene calcolato sulla base dei consumi storici del cliente a disposizione del Servizio Elettrico Nazionale.",
      labelKeywords: ["consumo", "stimato"],
      contentKeywords: ["consumo", "stimato"],
      img: "./images/03-consumi-01-consumifatturati-03-consumostimato.jpg",
      imgDescription: "Immagine che raffigura la seconda pagina della bolletta, con evidenziato il campo Consumo stimato"
    },

    "consumo-fatturato": {
      label: "Consumo fatturato",
      description: "Rappresenta il consumo fatturato nella bolletta per il periodo di competenza. È possibile che vi sia una differenza tra i consumi rilevati e i consumi fatturati che può dipendere dal fatto che ai consumi rilevati vengano aggiunti consumi stimati.",
      labelKeywords: ["consumo", "fatturato"],
      contentKeywords: ["consumo", "fatturato"],
      img: "./images/03-consumi-01-consumifatturati-04-consumofatturato.jpg",
      imgDescription: "Immagine che raffigura la seconda pagina della bolletta, con evidenziato il campo Consumo fatturato"
    },

    "andamento-consumi": {
      label: "Andamento consumi ultimi 12 mesi",
      description: "Una volta l'anno nella tua bolletta troverai esposto anche un grafico che ti indica l'andamento in tutto l'anno del tuo consumo rilevato, suddiviso per fasce F1, F2, F3 e riporta anche la media annua del tuo consumo espresso in kWh.",
      labelKeywords: ["andamento", "consumo", "consumi"],
      contentKeywords: ["andamento", "consumo", "consumi"],
      img: "./images/03-consumi-01-consumifatturati-05-andamentoconsumi.jpg",
      imgDescription: "Immagine che raffigura la seconda pagina della bolletta, con evidenziato l'area in cui è presente il grafico con l'andamento dei consum degli ultimi 12 mesi."
    }
}

export default data;